(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-promo-flash"] && !Shopify.designMode) return;
  try {
    (() => {
    const promo = document.querySelector('[data-product-promo-flash]');

    if (!promo) return;

    const startAt = Date.parse(promo.dataset.startAt);
    const endAt = Date.parse(promo.dataset.endAt);
    const label = promo.querySelector('[data-product-promo-label]');
    const countdown = promo.querySelector('[data-product-promo-countdown]');

    if (Number.isNaN(startAt) || Number.isNaN(endAt) || endAt <= startAt) return;

    const render = () => {
      const now = Date.now();

      if (now >= endAt) {
        promo.hidden = true;
        return;
      }

      const remaining = now < startAt ? startAt - now : endAt - now;
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);

      label.textContent = now < startAt ? promo.dataset.beforeLabel : promo.dataset.liveLabel;
      countdown.textContent = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
    };

    render();
    window.setInterval(render, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
